import type { TonApiClient } from '@ton-api/client'
import type { OpenedContract, Sender } from '@ton/core'
import type { TonClient } from '@ton/ton'
import type { BoxCollectionV0 } from '@voteboxio/core'
import type { useContactAddresses } from '../hooks/useContactAddresses'
import type { UserResponseDto } from '../types/generated'

export interface AppContextType {
  language: string
  client: TonClient | undefined
  boxCollection: OpenedContract<BoxCollectionV0.BoxCollectionV0> | undefined
  sender: Sender | undefined
  wallet: string | null
  tonApiClient: TonApiClient | null
  contractsAddresses: ReturnType<typeof useContactAddresses> | undefined
  basePath: string
  referralKey: string | null
  setReferralKey: (key: string | null) => void
  /** Referral key from browser URL or Telegram startParam - used for referral tracking */
  browserReferralKey: string | null
  authenticated: boolean
  setAuthenticated: (value: boolean) => void
  /** True when user is authenticated AND wallet is connected - safe to make auth requests */
  canFetchUserData: boolean
  userProfile: UserResponseDto | undefined
  isLoadingProfile: boolean
  isLoadingReferralKey: boolean
}

export const defaultContextValue: AppContextType = {
  language: '',
  client: undefined,
  boxCollection: undefined,
  sender: undefined,
  wallet: null,
  tonApiClient: null,
  contractsAddresses: undefined,
  basePath: '/',
  referralKey: null,
  setReferralKey: () => {},
  browserReferralKey: null,
  authenticated: false,
  setAuthenticated: () => {},
  canFetchUserData: false,
  userProfile: undefined,
  isLoadingProfile: false,
  isLoadingReferralKey: false,
}
